var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcFormBoxButton',{attrs:{"label":_vm.$t('calendar', 'Attachments folder'),"description":_vm.attachmentsFolder,"inverted-accent":""},on:{"click":_vm.selectCalendarFolder},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconFolderOpen',{attrs:{"size":20}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }